import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import { Icon } from "@cdk-uip/react-icon";

import { oneToHundredPattern } from "../../../../constants/constants";
import {
  getRelationShipName,
  getNomineeData
} from "../../../../util/onBoardingDataFilters";
import useValidation from "../../../../util/useValidation";

const GratuityNomineeDetails = ({
  gratuityNomination,
  handleOnChangeGratuityDetails,
  handleOnDeleteNominee,
  index,
  isEPFForm2,
  memberDetails,
  relationShipList
}) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  return (
    <Form.Group as={Row} controlId={`nominee-${index}`}>
      {!isEPFForm2 && <Col sm={1}>{index + 1}</Col>}
      <Col sm={isEPFForm2 ? 2 : 3}>
        <Form.Control
          size="sm"
          required
          type="text"
          name={`relationWithTheEmployee-${index}`}
          placeholder="Relation with the employee"
          value={getRelationShipName(
            memberDetails.relationShipType,
            relationShipList
          )}
          disabled
        />
      </Col>
      <Col sm={3}>
        <Form.Control
          size="sm"
          required
          type="text"
          placeholder="Name"
          name={`nameAddressOfNominee-${index}`}
          value={memberDetails.fullName}
          disabled
        />
      </Col>
      <Col sm={isEPFForm2 ? 2 : 1}>
        <Form.Control
          size="sm"
          required
          type="text"
          name={`ageOfNominee-${index}`}
          placeholder="Age"
          value={
            isEPFForm2
              ? memberDetails.dateOfBirth.split("T")[0]
              : memberDetails.age
          }
          disabled
        />
      </Col>
      {isEPFForm2 ? (
        <>
          <Col sm={2}>
            <Form.Control
              size="sm"
              pattern={oneToHundredPattern}
              required
              type="number"
              max="100"
              min="0"
              name="ePFSharePercentage"
              placeholder="Share in %"
              onChange={e => handleOnChangeGratuityDetails(e, memberDetails.id)}
              value={getNomineeData(
                gratuityNomination,
                "ePFSharePercentage",
                memberDetails.id
              )}
              onBlur={handleOnBlurInput}
              isInvalid={errors.ePFSharePercentage}
            />
            {errors.ePFSharePercentage && (
              <Form.Control.Feedback type="invalid">
                {errors.ePFSharePercentage.type === "required" &&
                  "EPF Share Percentage is required"}
                {errors.ePFSharePercentage.type === "unknown" &&
                  "EPF Share Percentage should be in between 1 and 100"}
              </Form.Control.Feedback>
            )}
          </Col>
          <Col sm={2}>
            <Form.Control
              size="sm"
              type="text"
              name="guradianName"
              placeholder="Guardian Name, Relation & Address"
              onChange={e => handleOnChangeGratuityDetails(e, memberDetails.id)}
              value={getNomineeData(
                gratuityNomination,
                "guradianName",
                memberDetails.id
              )}
            />
          </Col>
        </>
      ) : (
        <Col sm={3}>
          <Form.Control
            size="sm"
            required
            type="number"
            max="100"
            min="0"
            pattern={oneToHundredPattern}
            name="gratuityProprotionShared"
            placeholder="Gratuity Proportion"
            onChange={e => handleOnChangeGratuityDetails(e, memberDetails.id)}
            onBlur={handleOnBlurInput}
            isInvalid={errors.gratuityProprotionShared}
            value={getNomineeData(
              gratuityNomination,
              "gratuityProprotionShared",
              memberDetails.id
            )}
          />
          {errors.gratuityProprotionShared && (
            <Form.Control.Feedback type="invalid">
              {errors.gratuityProprotionShared.type === "required" &&
                "Gratuity Proportion is required"}
              {errors.gratuityProprotionShared.type === "unknown" &&
                "Gratuity Proportion should be in between 1 and 100"}
            </Form.Control.Feedback>
          )}
        </Col>
      )}
      <Col sm={1}>
        <Icon
          onClick={() => {
            handleOnDeleteNominee(memberDetails.id);
          }}
        >
          delete
        </Icon>
      </Col>
    </Form.Group>
  );
};

export default GratuityNomineeDetails;
